import { createSelector } from 'reselect';

import getSaleBody from './getSaleBody';

export default createSelector([getSaleBody], saleBody => ({
  ...saleBody,
  // PaymentType: 'cc',
  Payments: [], // We just pass this as a dummy value to validate the cart
}));
